export const app = `${
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:8061'
    : process.env.PUBLIC_URL
}`;
export const authApp = process.env.REACT_APP_AUTH_API;

export const paymentAPI = `${
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:8060/payments'
    : 'http://rajchandra.me/payments'
}`;
export const inventoryAPI = `${
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:8060/inventory'
    : 'http://rajchandra.me/inventory'
}`;
